import { IMAGES_CDN_BASE_URLS } from './__generated__/config.js';
import { resolveCdnEnv } from './resolveCdnEnv.js';

// This file is auto-generated by scripts/set-images-cdn-path.js during npm install or npm run build.
var raw = import.meta.env.REACT_APP_NODE_ENV ||
    (typeof process !== 'undefined' ? process.env.REACT_APP_NODE_ENV : undefined);
var CDN_BASE_PATH = IMAGES_CDN_BASE_URLS[resolveCdnEnv(raw)];

export { CDN_BASE_PATH };
//# sourceMappingURL=config.js.map
